
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Capacitor } from '@capacitor/core';

export const AuthStateHandler: React.FC = () => {
  const navigate = useNavigate();
  const hasSetupListener = useRef(false);
  const isCapacitorApp = Capacitor.isNativePlatform();

  useEffect(() => {
    if (hasSetupListener.current) return;
    
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      console.log("Auth state changed:", event);
      
      // Only redirect to home on explicit sign out events
      // Don't redirect on session refreshes or other events
      if (event === "SIGNED_OUT") {
        if (isCapacitorApp) {
          // In native apps, use navigate for better in-app experience
          console.log('User signed out in native app, navigating to home');
          navigate('/', { replace: true });
        } else {
          // In web, full page refresh can be better to clear state
          console.log('User signed out in browser, refreshing page');
          window.location.href = '/';
        }
      }
    });

    hasSetupListener.current = true;

    return () => {
      subscription.unsubscribe();
    };
  }, [navigate, isCapacitorApp]);

  return null;
};
